/** Strip zone apex from a FQDN so users can paste into DNS panels that auto-append the domain. */
export function toDnsRelativeHost(fullHost, domain) {
  if (!fullHost) return "";
  const host = String(fullHost).trim();
  const normalized = String(domain || "")
    .trim()
    .toLowerCase();
  if (!normalized) return host;
  if (host.toLowerCase() === normalized) return "@";
  const suffix = `.${normalized}`;
  if (host.toLowerCase().endsWith(suffix)) {
    const relative = host.slice(0, -suffix.length);
    return relative || "@";
  }
  return host;
}

export function getRowColor(domainRating) {
  if (domainRating >= 80) return 'rgba(102, 187, 106, 0.1)';
  if (domainRating >= 60) return 'rgba(255, 167, 38, 0.1)';
  if (domainRating >= 40) return 'rgba(239, 154, 154, 0.1)';
  return 'rgba(189, 189, 189, 0.1)';
}
